import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';

const ComplaintsChart = () => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [{
            label: 'Number of Complaints',
            data: [],
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
        }]
    });

    useEffect(() => {
        const fetchComplaints = async () => {
            const querySnapshot = await getDocs(collection(db, "feedbacks"));
            const complaintsTally = {};

            querySnapshot.forEach((doc) => {
                const complaintNature = doc.data().complaintNature;
                if (complaintsTally[complaintNature]) {
                    complaintsTally[complaintNature] += 1;
                } else {
                    complaintsTally[complaintNature] = 1;
                }
            });

            setChartData((prevChartData) => ({
                ...prevChartData,
                labels: Object.keys(complaintsTally),
                datasets: [{
                    ...prevChartData.datasets[0],
                    data: Object.values(complaintsTally),
                }]
            }));
        };

        fetchComplaints();
    }, []);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                borderRadius: 8,
                titleFont: {
                    size: 14,
                    weight: 'bold',
                },
                bodyFont: {
                    size: 13,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                },
                ticks: {
                    font: {
                        size: 12,
                    },
                },
            },
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        size: 11,
                    },
                },
            },
        },
    };

    return (
        <div className="h-80">
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default ComplaintsChart;
